import styled, { css } from 'styled-components'
import Colors from 'builder/styles/colors'
import Sizes from 'builder/styles/sizes'
import Typography, { FontWeights } from 'builder/styles/typography'
import Media from 'builder/styles/media'

export const SubHead = styled.div`
  display: flex;
  gap: 6px;
  color: ${Colors.Neutral90};
  ${Typography.Subhead}
  ${FontWeights.Medium}
`
export const TimeIcon = styled.div`
  & svg {
    width: 24px;
    height: 24px;
  }
  & path {
    stroke: ${Colors.Neutral50};
  }
`

export const WrapperToggle = styled.div`
  & div {
    margin: 0;
  }
`

export const Body = styled.div`
  display: flex;
  gap: 4px;
  color: ${Colors.Neutral50};
  ${Typography.Body}
  ${FontWeights.Regular}
  display: flex;
  overflow: hidden;
  & svg {
    flex-shrink: 0;
  }

  align-items: center;
`

export const Button = styled.div`
  display: flex;
  padding: ${Sizes['2XS']};
  justify-content: center;
  align-items: center;
  align-self: stretch;
  border-radius: 0px 0px ${Sizes['2XS']} ${Sizes['2XS']};
  background: ${Colors.Blue10};
  color: ${Colors.Blue50};
  gap: 4px;
  height: 40px;
  cursor: pointer;
`

const borderProps = (color: string) => `
  
  border-top: 1px solid ${color};
  border-right: 1px solid ${color};
  border-left: 1px solid ${color};
`

export const ContainerAlert = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-items: start;
  gap: 12px;
  border-radius: ${Sizes['2XS']};
  background: ${Colors.White};
  width: 100%;
  border-radius: 8px 8px 0px 0px;
  transition: border-color 100ms ease-out;
  ${borderProps(Colors.Neutral15)}
  padding: 16px 16px 12px;

  ${Media.AbovePhone`
    padding: 20px 24px 16px;
  `}
`

export const Container = styled.div<{ $active: boolean }>`
  ${props => {
    if (props.$active) {
      return `
        &:hover ${ContainerAlert} {
          ${borderProps(Colors.Blue30)}
        }

        &:hover ${Button} {
          background-color: ${Colors.Blue20};
          color: ${Colors.Blue50};
        }
      `
    }

    return css`
      ${ContainerAlert} {
        ${borderProps(Colors.Neutral15)}
      }

      ${Button} {
        background-color: ${Colors.Neutral20};
        color: ${Colors.Neutral50};
      }
    `
  }}
`

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow: hidden;
`
export const ContainerText = styled.div`
  display: flex;
  padding-top: 6px;
  flex-wrap: wrap;
  gap: 4px;

  ${Media.Phone`
    flex-direction: column;
  `}

  ${Media.AbovePhone`
    gap: 10px;
  `}
`
